<template>
  <span
    class="connection-dot"
    :class="connected ? 'connection-dot-connected' : 'connection-dot-disconnected'"
    role="img"
    :aria-label="label"
    :title="label"
  ></span>
</template>

<script>
export default {
  name: 'base-connection-dot',
  props: {
    connected: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    label () {
      return this.connected
        ? this.$t('dashboard.connected_users_status_connected')
        : this.$t('dashboard.connected_users_status_disconnected')
    }
  }
}
</script>

<style scoped>
.connection-dot {
  display: inline-block;
  flex: none;
  width: 14px;
  height: 14px;
  border-radius: 9999px;
}

/* .connection-dot-connected {
  background-color: #139b45;
}

.connection-dot-disconnected {
  background-color: #df3131;
} */

.connection-dot-connected {
  background-color: var(--primary-800);
}

.connection-dot-disconnected {
    border-color: var(--primary-800);
    border-width: 2px;
    border-style: solid;
}
</style>
